import { render, staticRenderFns } from "./CricketRound.vue?vue&type=template&id=5cf2da71&scoped=true&"
import script from "./CricketRound.vue?vue&type=script&lang=js&"
export * from "./CricketRound.vue?vue&type=script&lang=js&"
import style0 from "./CricketRound.vue?vue&type=style&index=0&id=5cf2da71&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf2da71",
  null
  
)

export default component.exports